import AnnouncementModal from '@/components/Modal/AnnouncementModal'
import ECCNDetailModal from '@/features/vendors/components/Modal/ECCNDetailModal'
import QuotationDetailModal from '@/features/vendors/components/Modal/QuotationDetailModal'
import { hideModal } from '@/stores/ui/modal/modalSlice'
import { MODAL_TYPES } from '@/utils/constants/modalTypes'
import modalCallbackRegistry from '@/utils/modalCallbackRegistry'
import { useDispatch, useSelector } from 'react-redux'

const ModalRoot = () => {
  const { modalType, modalProps } = useSelector((state) => state.modal)
  const dispatch = useDispatch()

  const injectedProps = {
    ...modalProps,
    ...modalCallbackRegistry, // ⬅️ inject callbacks without storing in Redux
  }

  const handleClose = () => {
    dispatch(hideModal())

    // optional: clean up
    Object.keys(modalCallbackRegistry).forEach((key) => (modalCallbackRegistry[key] = null))
  }

  switch (modalType) {
    case MODAL_TYPES.VIEW_QUOTATION_DETAIL:
      return <QuotationDetailModal {...injectedProps} onClose={handleClose} />
    case MODAL_TYPES.ECCN_DETAIL:
      return <ECCNDetailModal {...injectedProps} onClose={handleClose} />
    case MODAL_TYPES.ANNOUNCEMENT:
      return <AnnouncementModal {...injectedProps} onClose={handleClose} />

    default:
      return null // no modal open
  }
}

export default ModalRoot
